import NavBar from '../../navBar/index';
import NavTabs from '../../navTabs';
import Footer from '../../footer';
import { useLocation } from 'react-router-dom';

const Layout = ({ children }) => {
  const location = useLocation();
  const showBackOfficeTabs = location.pathname === '/backoffice' || location.pathname.startsWith('/backoffice/');

  return (
    <div className="app-container">
      <NavBar />
      <div className={`app-body ${showBackOfficeTabs ? 'app-body--with-sidebar' : ''}`}>
        {showBackOfficeTabs && (
          <aside className="reservations-sidebar" aria-label="Navegación de BackOffice">
            <NavTabs />
          </aside>
        )}
        <div className="app-content">
          {children}
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Layout;
